import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { fetchUsersTx } from '../../actions'
import { resetCSVExport } from '../../actions/csv_export'
import { disableStatusFilter, enableStatusFilter } from '../../actions/status_filter'
import {
  TX_STATUS_COMPLETED,
  TX_STATUS_FAILED,
  TX_STATUS_HOLD,
  TX_STATUS_NEW,
  TX_STATUS_POST_PROCESSING,
  TX_STATUS_RESTARTED,
} from '../../config'
import { transactionStateLabel } from '../../utils/display_names'

const StatusFilter = (props) => {
  const defaultFilter = 'Status: No Filter'
  const allFilters = [
    TX_STATUS_NEW,
    TX_STATUS_COMPLETED,
    TX_STATUS_FAILED,
    TX_STATUS_HOLD,
    TX_STATUS_RESTARTED,
    TX_STATUS_POST_PROCESSING,
  ].sort()

  const handleSelectFilter = (e) => {
    const status = e.target.value === defaultFilter ? null : e.target.value
    props.updateFilter({ status })
  }

  const selectedFilter = props.filter ? props.filter : defaultFilter
  return (
    <div className='form-group'>
      <select value={selectedFilter} name='status' id='status' className='form-control' onChange={handleSelectFilter}>
        <option key={defaultFilter} defaultValue={defaultFilter}>
          {defaultFilter}
        </option>
        {allFilters.map((status) => (
          <option key={status} value={status}>
            {transactionStateLabel(status).toUpperCase()}
          </option>
        ))}
      </select>
    </div>
  )
}

const mapStateToProps = (state) => ({
  searchTerm: state.transactionSearch.searchTerm,
})

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      enableStatusFilter,
      disableStatusFilter,
      fetchUsersTx,
      resetCSVExport,
      navigateToPage: (p) => ownProps.history.push('#/page/' + p),
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(StatusFilter))
